import e from "@dialpad/dialtone-tokens/layered/themes/tokens-mushroom-colors.css?inline";
//#region themes/mushroom.js
var t = {
	brand: {
		css: e,
		name: "mushroom"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
